import locales from '@/config/locales.config.js';

export default () => {
    const currentPrismicLocale = process.env.PRISMIC_LOCALE;
    const currentLocale = locales.find(locale => locale.prismic === currentPrismicLocale);
    return currentLocale;
};